import Cookies from 'js-cookie'

const TokenKey = 'shoptoken'
const PartnerIdKey="PartnerIdKey"
const payUrlKey="payUrlKey"
const payUrlName="payUrlName"
const homePageUrlKey="homePageUrlKey"
const titleKey="titleKey"
export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}
export function setPartnerId(id) {
  return Cookies.set(PartnerIdKey, id)
 
}

export function setPayUrlKey(payUrl) {
  return Cookies.set(payUrlKey, payUrl)

}
export function setName(UrlName) {
  return Cookies.set(payUrlName, UrlName)

}
export function setUrlTitle(name) {

  return Cookies.set(titleKey, name)

}
export function setHomePage(homPageUrl) {

  return Cookies.set(homePageUrlKey, homPageUrl)
 
}
export function getPartnerId() {
  return Cookies.get(PartnerIdKey)?Cookies.get(PartnerIdKey):''
}
export function getPayUrlKey() {
  return Cookies.get(payUrlKey)?Cookies.get(payUrlKey):''
}
export function getHomePage() {
  return Cookies.get(homePageUrlKey)?Cookies.get(homePageUrlKey):''
}
export function getName() {
  return Cookies.get(payUrlName)?Cookies.get(payUrlName):''
}
export function getUrlTitle() {
  return Cookies.get(titleKey)

}
export function removePartnerId() {
  return Cookies.remove(PartnerIdKey)
}
export function removePayUrlKey() {
  return Cookies.remove(payUrlKey)
}
export function removeHomePage() {
  return Cookies.remove(payUrlName)
}
export function removeName() {
  return Cookies.remove(payUrlName)
}



